import React from "react";
import type { AnchorProps } from "tamagui";
import { Anchor, Text, XStack } from "tamagui";

import type { authClient } from "~/utils/auth";

export type SocialButtonAuthParams = Partial<
  Parameters<typeof authClient.signIn.social>[0]
>;
export interface SocialButtonProps extends AnchorProps {
  Icon: React.FunctionComponent;
}

export const SocialButton: React.FC<SocialButtonProps> = ({
  Icon,
  ...props
}) => {
  return (
    <Anchor
      fontWeight={"$5"}
      fontFamily={"$body"}
      fontSize={"$2"}
      borderColor={"$gray-150"}
      borderWidth={"$0.1"}
      borderRadius={"$0.5"}
      paddingHorizontal={"$3.3"}
      textAlign={"center"}
      textDecorationLine={"none"}
      cursor={"pointer"}
      width={"100%"}
      opacity={1}
      hoverStyle={{ backgroundColor: "$gray-50" }}
      disabledStyle={{
        opacity: 0.5,
        cursor: "not-allowed",
        borderColor: "$gray-200",
        backgroundColor: "$gray-200",
      }}
      {...props}
    >
      <XStack
        height={"$5"}
        alignItems={"center"}
        gap="$2"
        justifyContent={"center"}
      >
        <Icon />
        <Text color={"$gray-800"}>{props.children}</Text>
      </XStack>
    </Anchor>
  );
};
